import { HttpHeaders } from '@angular/common/http';
import { Injectable, Injector, inject } from '@angular/core';

import { map } from 'rxjs';

import { AuthDetailsStore } from '../auth/auth-details-store';
import { PaymentsCashierConfig } from '../client-config/client-config.models';
import { CustomHttpClientService } from '../http/custom-http-client.service';
import { PaymentsAuthenticationService } from './payments-authentication.service';

@Injectable({
    providedIn: 'root',
})
export class PaymentsCustomApiService {
    protected customHttpClientService = inject(CustomHttpClientService);
    protected authService = inject(PaymentsAuthenticationService);
    protected injector = inject(Injector);
    protected authDetailsStore = inject(AuthDetailsStore);

    getHttpHeaders(type?: string): HttpHeaders {
        const headerConfig: Record<string, string> = {
            Accept: 'application/json',
        };

        if (this.authDetailsStore.getAuthDetails().authCode) {
            headerConfig['auth-code'] = this.authDetailsStore.getAuthDetails().authCode;
        }

        if (type !== 'GET') {
            headerConfig['Content-Type'] = 'application/json';
        }

        return new HttpHeaders(headerConfig);
    }

    getHttpOptions(type?: string) {
        return {
            headers: this.getHttpHeaders(type),
            observe: 'response' as 'body',
            withCredentials: true,
        };
    }

    post(url: string, requestData: any) {
        const host = this.injector.get(PaymentsCashierConfig).host;
        return this.customHttpClientService.httpClient.post(host + url, requestData, this.getHttpOptions()).pipe(map((data: any) => data.body));
    }

    put(url: string, requestData: any) {
        const host = this.injector.get(PaymentsCashierConfig).host;
        return this.customHttpClientService.httpClient.put(host + url, requestData, this.getHttpOptions()).pipe(map((data: any) => data.body));
    }

    get(url: string) {
        const host = this.injector.get(PaymentsCashierConfig).host;
        return this.customHttpClientService.httpClient.get(host + url, this.getHttpOptions('GET')).pipe(map((data: any) => data.body));
    }

    postPgwRequest(url: string, requestData: any, cardToken?: any) {
        const headers = {
            'Content-Type': 'application/json; charset=utf-8',
            'Accept': 'application/json',
            'token': cardToken || '',
        };

        return this.customHttpClientService.httpClient.post(url, requestData, { headers }).pipe(map((data: any) => data.body));
    }
}
